import { createUseStyles } from "react-jss";

const useStyles = createUseStyles((theme: any) => ({
  root: {
    borderRadius: "10px",
    backgroundColor: theme.colors.white,
    width: "800px",
    maxWidth: '90vw',
    overflow: "auto",
    margin: "20px",
    maxHeight: 'calc(100vh - 40px)',
  },
  wrapper: {
    display: "flex",
    alignItems: "center",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "20px 20px 0 20px",
    '& p': {
      fontWeight: "bold",
      marginBottom: "0",
    },
  },
  text: {
    '& a': {
      color: theme.colors.primaryBlue[500],
    },
  },
  body: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    margin: "20px 0",
    position: 'relative',
    maxHeight: 'calc(100vh - 300px)',
    overflow: 'auto',
    height: '100%',
  },
  footer: {
    display: "flex",
    gap: '15px',
    padding: "20px",
    justifyContent: "flex-end",
    flexWrap: 'wrap',
    width: 'calc(100% - 40px)',
    '& > button': {
      width: 'fit-content',
    },
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    padding: "0 25px",
    width: 'calc(100% - 50px)',
    flexDirection: 'row',
    '& > p': {
      fontSize: '14px',
    },
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      gap: '10px',
      alignItems: 'flex-start',
      justifyContent: 'center',
    },
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '14px',
    fontWeight: 'bold',
    color: theme.colors.grey[520],
    width: '200px',
    flex: '0 0 200px',
    '& > svg': {
      width: '18.5px',
      height: '18.5px',
      marginRight: '8px',  
    },
    [theme.breakpoints.down('md')]: {
      flex: 'unset',
      width: 'unset',
    },
  },
  detail: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '16px',
    '& > p': {
      fontSize: '14px',
      '& + div': {
        '& > span': {
          marginLeft: '-9px',
        },
      },
    },
  },
  childrenCount: {
    backgroundColor: theme.colors.grey[250],
    borderRadius: "20px",
    marginLeft: "10px",
    padding: "2px 5px",
    display: "flex",
    alignItems: "center",
    '& > svg': {
      color: theme.colors.primaryBlue[500],
    },
    '& > span': {
      marginBottom: "0",
      marginLeft: "5px",
      color: theme.colors.primaryBlue[500],
      fontWeight: "bold",
      fontSize: '16px',
    }
  },
  childPhoto: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    maxWidth: '100%',
    margin: '0px 5px',
    position: 'relative',
    '& > div': {
      backgroundColor: 'transparent',
      borderRadius: '50%',
      minWidth: '36px',
      minHeight: '36px',
      width: '36px',
      height: '36px',
      maxWidth: '36px',
      maxHeight: '36px',
    },
    '& > p': {
      fontSize: '14px',
      marginLeft: '16px',
      maxWidth: '100%',
      textAlign: 'center',
      marginBottom: '0',
      color: '#9B9EBB',
    },
  },
  nickname: {
    maxWidth: '100%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',  
  },
  timezones: {
    padding: "0 25px",
    width: 'calc(100% - 50px)',
    '&:empty': {
      display: 'none',
    }
  },
  timezone: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    '& > span': {
      display: 'flex',
      alignItems: 'center',
      color: '#C2C4D9',
      fontSize: '13px',
      marginBottom: '5px',
      [theme.breakpoints.down('sm')]: {
        fontSize: '11px',
      },
      '& > svg': {
        width: '18px',
        height: '18px',
        marginRight: '4px',
        marginLeft: '-2px',
        marginTop: '-2px',
      },
    },
  },
  classInputSelect: {
    width: '100%',
  },
  customClassesSelect: {
    backgroundImage: theme.colors.gradient,
    overflow: 'auto',
    maxHeight: 'calc(100vh - 400px)',
  },
  customSearch: {
    padding: '0 24px 24px 24px',
  },
  customSchoolList: {
    maxHeight: 'unset !important',
  },
  capacityInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    color: theme.colors.grey[650],
    fontWeight: 'bold',
  },
}));

export default useStyles;